module.exports = __webpack_public_path__ + "static/img/success-icon.d53392b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/success-icon.svg
// module id = 2VhF
// module chunks = 1